import styled from 'styled-components';
import { Cell } from '@grnhse/seedling/lib/azalea/components/card_table';

export const TableCell = styled(Cell)`
  padding-right: 24px;
`;

export default TableCell;
